import React, { Component } from 'react'
import { navigate } from 'gatsby'

import * as El from './styles'

export default class Stage extends Component {
  componentWillUpdate (nextProps) {
    // scroll to agb if it is not selected
    if (
      nextProps.nr === 6 &&
      nextProps.stage === 6 &&
      !nextProps.agb_selected
    ) {
      document.getElementById('accept_terms').scrollIntoView()
    }
  }

  render () {
    const {
      children,
      nextStage,
      nr,
      stage,
      name,
      formik,
      form_s,
      buttonName
    } = this.props

    return (
      <El.Stage visible={nr === stage} main={nr === 0}>
        <El.StageBody>{children}</El.StageBody>
        {nextStage && (
          <El.Center next>
            <El.NextBtn onClick={() => nextStage(formik, name, nr + 1, form_s)}>
              {buttonName || form_s.buttons.next_button}
            </El.NextBtn>
          </El.Center>
        )}
        <El.Center cancel>
          <El.CancelBtn
            onClick={() => navigate(`${form_s.locale === 'de' ? '/' : '/en/'}`)}
          >
            {form_s.buttons.cancel_button}
          </El.CancelBtn>
        </El.Center>
      </El.Stage>
    )
  }
}
